import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { CorpusFeedStatistics } from "@shared/types/corpus/api.ts";
import { SectionLabel } from "../../../../../components/primitives/data-display/SectionLabel";
import { EmptyState } from "../../../../../components/primitives/feedback/EmptyState";
import { gaps } from "../../../../../components/primitives/spacing";
import {
  FeedOutcomeBar,
  FeedOutcomeLegend,
} from "../../../../../components/domain/data-display/FeedOutcomeBar";
import { FeedFactsSkeleton } from "./FeedFactsSkeleton";

interface FeedOutcomesProps {
  /** Undefined until the statistics arrive. */
  statistics?: CorpusFeedStatistics;
  /** The statistics could not be loaded. */
  unavailable: boolean;
}

/** What became of the papers a feed returned, as a bar and a count for each kind of outcome. While
 *  the numbers load it draws the shape they will take; a feed that has returned nothing says so. */
export function FeedOutcomes({ statistics, unavailable }: FeedOutcomesProps) {
  return (
    <Stack gap={gaps.snug}>
      <SectionLabel>What became of its papers</SectionLabel>
      {statistics ? (
        statistics.returnedCount === 0 ? (
          <EmptyState
            title="No papers yet"
            message="Nothing has run yet, or the feed's runs found nothing. What becomes of the papers it returns will show here."
          />
        ) : (
          <>
            <FeedOutcomeBar statistics={statistics} />
            <FeedOutcomeLegend statistics={statistics} />
          </>
        )
      ) : unavailable ? (
        <Typography variant="body2" color="text.secondary">
          The numbers could not be loaded.
        </Typography>
      ) : (
        <>
          <Skeleton variant="rounded" height={8} />
          <FeedFactsSkeleton rows={4} />
        </>
      )}
    </Stack>
  );
}
